import React from 'react';
import {
  LayoutPage,
  LayoutContent,
  AcceptedCreditLimit,
  BenefitInfo,
  Form,
  SaveAndCompleteLaterButton,
} from 'components';
import { Container, Text, Grid, Button } from 'basis';
import { useFormInitialValues } from 'hooks';
import { useTheme } from '@emotion/react';
import { getMaxCreditLimit } from 'utils';
import { PrimaryButtonWrapper } from 'components/form/FormButtons';

export const DclReferred = ({ onSubmit, submitting }) => {
  const initialValues = useFormInitialValues('confirmReferredCreditLimit');
  const theme = useTheme();

  return (
    <LayoutPage>
      <Container margin="0 0 13 0" hasBreakpointWidth>
        <Form
          id="confirmReferredCreditLimit"
          initialValues={initialValues}
          onSubmit={onSubmit}
          disableFormCache
          hideFormButtons
        >
          {formData => {
            return (
              <>
                <LayoutContent rowsGap="0" noSessionTimeout>
                  <Container margin="8 0 0 0">
                    <Text as="h1" textStyle="heading5" textStyle-md="heading4" color={theme?.headingColor}>
                      Choose your credit card limit
                    </Text>
                    <Container margin="10 0 5 0">
                      <Text>
                        Please consider your needs, when deciding a credit card limit. It is important that you are{' '}
                        comfortable with your credit limit*.
                      </Text>
                    </Container>
                    <AcceptedCreditLimit formData={formData} maxCreditLimit={getMaxCreditLimit()} />
                    <Container margin="8 0" />
                    <BenefitInfo />
                  </Container>
                  <Container margin="8 0 0 0">
                    <Grid rowsGap="4" colsGap="10" cols="2">
                      <Grid.Item colSpan="all" colSpan-sm="0" alignItems="center">
                        <PrimaryButtonWrapper>
                          <Grid>
                            <Button width="100%" type="submit" loading={submitting}>
                              Submit
                            </Button>
                          </Grid>
                        </PrimaryButtonWrapper>
                      </Grid.Item>
                      <Grid.Item colSpan="all" rowSpan="1" colSpan-sm="1" rowSpan-sm="0">
                        <Grid>
                          <SaveAndCompleteLaterButton />
                        </Grid>
                      </Grid.Item>
                    </Grid>
                  </Container>
                </LayoutContent>
              </>
            );
          }}
        </Form>
      </Container>
    </LayoutPage>
  );
};
